// extracted by mini-css-extract-plugin
export var base = "_3u-0";
export var updateBanner = "_3u-1";